export type ErrorSnackbarState = {
    open: boolean;
    message: string;
    params: Record<string, string | number> | null;
    rebooker: boolean;
};

export enum ErrorSnackbarActionType {
    ERROR_BASKET_OUTDATED = 'BASKET_OUT_OF_DATE',
    PROMOTION_EXPIRED = 'PROMOTION_EXPIRED',
    ALREADY_HAS_BOOKING = 'ALREADY_HAS_BOOKING',
    BASE_PRICE_MISMATCH = 'BASE_PRICE_MISMATCH',

    ERROR_APPLY_REFERRAL_CODE = 'ERROR_APPLYING_REFERRAL_CODE',
    ERROR_CLEAR_REFERRAL_CODE = 'ERROR_CLEARING_REFERRAL_CODE',
    ERROR_APPLY_REFERRAL_CODE_HOS = 'ERROR_APPLYING_REFERRAL_CODE_HOS',
    ERROR_CLEAR_REFERRAL_CODE_HOS = 'ERROR_CLEARING_REFERRAL_CODE_HOS',

    SOMETHING_WENT_WRONG = 'SOMETHING_WENT_WRONG',
    CLOSE_SNACKBAR = 'CLOSE SNACKBAR',

    REBOOKER_PRICE_CHANGED = 'REBOOKER_PRICE_CHANGED',
}

export interface ErrorSnackbarAction {
    type: ErrorSnackbarActionType;
    payload: Record<string, string | number> | null;
}
